export default "__VITE_ASSET__Bx_T$NqX__"